export const GbpRestrictions = {
	"2025-01-02": {
		high: 37.48976503,
		low: 19.90965561
	},
	"2025-01-03": {
		high: 37.32412302,
		low: 19.77026146
	},
	"2025-01-06": {
		high: 37.64163842,
		low: 19.651174
	},
	"2025-01-07": {
		high: 37.56844131,
		low: 19.93999928
	},
	"2025-01-08": {
		high: 37.98360483,
		low: 19.82042145
	},
	"2025-01-09": {
		high: 37.49233618,
		low: 20.03852339
	},
	"2025-01-10": {
		high: 37.35666794,
		low: 20.04819546
	},
	"2025-01-13": {
		high: 37.39553156,
		low: 19.91215186
	},
	"2025-01-14": {
		high: 38.03614883,
		low: 20.2767819
	},
	"2025-01-15": {
		high: 38.79041446,
		low: 20.8508776
	},
	"2025-01-16": {
		high: 40.67114344,
		low: 21.31738922
	},
	"2025-01-17": {
		high: 40.89853978,
		low: 21.80225613
	},
	"2025-01-20": {
		high: 41.22769594,
		low: 22.06767295
	},
	"2025-01-21": {
		high: 41.52410575,
		low: 22.08698415
	},
	"2025-01-22": {
		high: 41.42447605,
		low: 21.99115078
	},
	"2025-01-23": {
		high: 41.19440132,
		low: 21.89992621
	},
	"2025-01-24": {
		high: 41.39706253,
		low: 21.41598067
	},
	"2025-01-28": {
		high: 40.9341518,
		low: 21.34409292
	},
	"2025-01-29": {
		high: 40.48245013,
		low: 21.38235618
	},
	"2025-01-30": {
		high: 40.3555379,
		low: 21.30241319
	},
	"2025-01-31": {
		high: 41.05959442,
		low: 21.73588149
	},
	"2025-02-03": {
		high: 39.47029268,
		low: 20.66321572
	},
	"2025-02-04": {
		high: 40.01675806,
		low: 20.84513172
	},
	"2025-02-05": {
		high: 39.75387942,
		low: 20.88644087
	},
	"2025-02-06": {
		high: 40.77406384,
		low: 21.48978638
	},
	"2025-02-07": {
		high: 40.92961421,
		low: 21.75076807
	},
	"2025-02-10": {
		high: 40.37574594,
		low: 21.58848445
	},
	"2025-02-11": {
		high: 40.45291759,
		low: 21.45912465
	},
	"2025-02-12": {
		high: 40.23583928,
		low: 21.10093416
	},
	"2025-02-13": {
		high: 40.23163439,
		low: 20.52159133
	},
	"2025-02-14": {
		high: 39.66217932,
		low: 20.60672085
	},
	"2025-02-17": {
		high: 39.01757239,
		low: 20.13138
	},
	"2025-02-18": {
		high: 38.89255779,
		low: 20.10094183
	},
	"2025-02-19": {
		high: 40.64480521,
		low: 20.30494896
	},
	"2025-02-20": {
		high: 39.48585724,
		low: 20.29901847
	},
	"2025-02-21": {
		high: 39.33501106,
		low: 20.34824144
	},
	"2025-02-24": {
		high: 39.14682918,
		low: 19.73184384
	},
	"2025-02-25": {
		high: 37.63938752,
		low: 19.50183506
	},
	"2025-02-26": {
		high: 39.04678425,
		low: 19.7579847
	},
	"2025-02-27": {
		high: 39.1782393,
		low: 20.06123872
	},
	"2025-02-28": {
		high: 38.39660352,
		low: 19.88687688
	},
	"2025-03-03": {
		high: 38.62872507,
		low: 19.84774825
	},
	"2025-03-04": {
		high: 38.46134551,
		low: 19.73950273
	},
	"2025-03-05": {
		high: 38.89332269,
		low: 19.67838088
	},
	"2025-03-06": {
		high: 39.07238229,
		low: 19.89833978
	},
	"2025-03-07": {
		high: 39.06332753,
		low: 19.71526317
	},
	"2025-03-10": {
		high: 38.52692641,
		low: 19.60357596
	},
	"2025-03-11": {
		high: 38.6041151,
		low: 19.49428186
	},
	"2025-03-12": {
		high: 38.14301419,
		low: 19.15276968
	},
	"2025-03-13": {
		high: 37.66636922,
		low: 19.06659997
	},
	"2025-03-14": {
		high: 38.06693518,
		low: 19.33481143
	},
	"2025-03-17": {
		high: 38.76674474,
		low: 19.61895409
	},
	"2025-03-18": {
		high: 38.96748257,
		low: 19.66623337
	},
	"2025-03-19": {
		high: 38.66070804,
		low: 19.0748815
	},
	"2025-03-20": {
		high: 36.78699679,
		low: 18.05203548
	},
	"2025-03-21": {
		high: 35.51515531,
		low: 17.6723128
	},
	"2025-03-24": {
		high: 32.40042989,
		low: 15.46261066
	},
	"2025-03-25": {
		high: 29.29964399,
		low: 14.63988446
	},
	"2025-03-26": {
		high: 28.91074645,
		low: 14.7003816
	},
	"2025-03-27": {
		high: 29.54334878,
		low: 14.65780467
	},
	"2025-03-28": {
		high: 29.84571666,
		low: 14.9668272
	},
	"2025-03-31": {
		high: 29.42624077,
		low: 14.66003873
	},
	"2025-04-01": {
		high: 28.51315137,
		low: 14.23182864
	},
	"2025-04-02": {
		high: 27.91330302,
		low: 13.91399559
	},
	"2025-04-03": {
		high: 28.94219028,
		low: 14.00282978
	},
	"2025-04-04": {
		high: 26.30726851,
		low: 12.83376861
	},
	"2025-04-07": {
		high: 25.03949447,
		low: 11.99253167
	},
	"2025-04-08": {
		high: 24.87466806,
		low: 12.42199798
	},
	"2025-04-09": {
		high: 24.60156851,
		low: 12.34239262
	},
	"2025-04-10": {
		high: 27.06570433,
		low: 13.37010836
	},
	"2025-04-11": {
		high: 26.35928829,
		low: 13.01597561
	},
	"2025-04-14": {
		high: 27.24805981,
		low: 13.48542735
	},
	"2025-04-15": {
		high: 26.94842053,
		low: 13.3072087
	},
	"2025-04-16": {
		high: 26.23000936,
		low: 13.05742385
	},
	"2025-04-17": {
		high: 26.81491421,
		low: 13.03328295
	},
	"2025-04-22": {
		high: 26.27475192,
		low: 12.92486057
	},
	"2025-04-23": {
		high: 27.38701616,
		low: 13.40211023
	},
	"2025-04-24": {
		high: 28.41742987,
		low: 13.82009329
	},
	"2025-04-28": {
		high: 29.43653912,
		low: 13.98623414
	},
	"2025-04-29": {
		high: 28.39677121,
		low: 13.8757307
	},
	"2025-04-30": {
		high: 28.58624465,
		low: 14.11261398
	},
	"2025-05-01": {
		high: 28.5243767,
		low: 14.17059451
	},
	"2025-05-02": {
		high: 29.56883612,
		low: 14.51207164
	},
	"2025-05-05": {
		high: 29.68356927,
		low: 14.46479032
	},
	"2025-05-06": {
		high: 29.24511153,
		low: 14.3904762
	},
	"2025-05-07": {
		high: 28.90359047,
		low: 14.2460621
	},
	"2025-05-08": {
		high: 28.54217592,
		low: 13.93224055
	},
	"2025-05-09": {
		high: 29.38031311,
		low: 14.34082394
	},
	"2025-05-12": {
		high: 29.84979552,
		low: 14.80214001
	},
	"2025-05-13": {
		high: 31.31521577,
		low: 15.20192104
	},
	"2025-05-14": {
		high: 30.99898469,
		low: 15.26060584
	},
	"2025-05-15": {
		high: 30.73335725,
		low: 15.00400067
	},
	"2025-05-16": {
		high: 30.15936,
		low: 14.77524531
	},
	"2025-05-19": {
		high: 30.09622894,
		low: 14.65806982
	},
	"2025-05-20": {
		high: 29.95781404,
		low: 14.64371997
	},
	"2025-05-21": {
		high: 28.49420849,
		low: 13.54429653
	},
	"2025-05-22": {
		high: 28.26814353,
		low: 13.74214248
	},
	"2025-05-23": {
		high: 28.89575811,
		low: 13.93217705
	},
	"2025-05-26": {
		high: 27.91312804,
		low: 13.52521284
	},
	"2025-05-27": {
		high: 27.75648006,
		low: 13.43290455
	},
	"2025-05-28": {
		high: 27.57521623,
		low: 13.20495028
	},
	"2025-05-29": {
		high: 26.81266304,
		low: 13.0280867
	},
	"2025-05-30": {
		high: 27.5889567,
		low: 13.39814916
	},
	"2025-06-02": {
		high: 28.68867361,
		low: 13.78681661
	},
	"2025-06-03": {
		high: 28.64803747,
		low: 13.65344222
	},
	"2025-06-04": {
		high: 30.15437326,
		low: 14.50593076
	},
	"2025-06-05": {
		high: 30.95691757,
		low: 14.95005024
	},
	"2025-06-06": {
		high: 31.78003233,
		low: 15.33533449
	},
	"2025-06-10": {
		high: 32.63667062,
		low: 15.81098773
	},
	"2025-06-11": {
		high: 32.95255176,
		low: 15.81306406
	},
	"2025-06-12": {
		high: 32.64191855,
		low: 15.57960751
	},
	"2025-06-13": {
		high: 32.05904863,
		low: 15.26736499
	},
	"2025-06-16": {
		high: 31.77025256,
		low: 15.3420918
	},
	"2025-06-17": {
		high: 30.77221877,
		low: 14.89821419
	},
	"2025-06-18": {
		high: 30.24186464,
		low: 14.49018916
	},
	"2025-06-19": {
		high: 29.25008263,
		low: 14.28842147
	},
	"2025-06-20": {
		high: 29.0946149,
		low: 14.13252885
	},
	"2025-06-23": {
		high: 28.86392849,
		low: 14.02433385
	},
	"2025-06-24": {
		high: 29.85639975,
		low: 14.32700313
	},
	"2025-06-25": {
		high: 30.78085216,
		low: 14.5347658
	},
	"2025-06-26": {
		high: 30.88108264,
		low: 14.70976588
	},
	"2025-06-27": {
		high: 31.06981239,
		low: 14.73035117
	},
	"2025-06-30": {
		high: 33.80270569,
		low: 15.75395431
	},
	"2025-07-01": {
		high: 32.86308364,
		low: 15.51819803
	},
	"2025-07-02": {
		high: 35.27971245,
		low: 16.36382473
	},
	"2025-07-03": {
		high: 34.38481245,
		low: 16.34064271
	},
	"2025-07-04": {
		high: 34.30884511,
		low: 16.30101148
	},
	"2025-07-07": {
		high: 34.05414874,
		low: 16.3395208
	},
	"2025-07-08": {
		high: 34.14936757,
		low: 16.40467946
	},
	"2025-07-09": {
		high: 33.79121956,
		low: 16.12343062
	},
	"2025-07-10": {
		high: 33.87039403,
		low: 16.41493554
	},
	"2025-07-11": {
		high: 34.12400837,
		low: 16.4979574
	},
	"2025-07-14": {
		high: 33.1023653,
		low: 16.08100893
	},
	"2025-07-15": {
		high: 32.33200706,
		low: 15.89471464
	},
	"2025-07-16": {
		high: 31.66941847,
		low: 15.435614
	},
	"2025-07-17": {
		high: 31.91613581,
		low: 15.43916411
	},
	"2025-07-18": {
		high: 32.19117905,
		low: 15.78553375
	},
	"2025-07-21": {
		high: 31.89740646,
		low: 15.59946146
	},
	"2025-07-22": {
		high: 31.81302801,
		low: 15.35597963
	},
	"2025-07-23": {
		high: 33.21363504,
		low: 15.95914514
	},
	"2025-07-24": {
		high: 33.50113331,
		low: 16.24015866
	},
	"2025-07-25": {
		high: 32.81185376,
		low: 16.02887548
	},
	"2025-07-28": {
		high: 32.60537947,
		low: 16.06139397
	},
	"2025-07-29": {
		high: 32.67657339,
		low: 16.06879991
	},
	"2025-07-30": {
		high: 32.84171528,
		low: 16.15402469
	},
	"2025-07-31": {
		high: 32.00143942,
		low: 16.01220306
	},
	"2025-08-01": {
		high: 31.53069153,
		low: 15.6048692
	},
	"2025-08-04": {
		high: 31.60815102,
		low: 15.55427587
	},
	"2025-08-05": {
		high: 32.11956522,
		low: 15.8172058
	},
	"2025-08-06": {
		high: 33.91192417,
		low: 16.35592308
	},
	"2025-08-07": {
		high: 33.6351302,
		low: 16.44597213
	},
	"2025-08-08": {
		high: 33.76565762,
		low: 16.54359943
	},
	"2025-08-11": {
		high: 34.24262355,
		low: 16.71733629
	},
	"2025-08-12": {
		high: 33.98745701,
		low: 16.52718378
	},
	"2025-08-13": {
		high: 34.77083129,
		low: 16.83881598
	},
	"2025-08-14": {
		high: 35.66439014,
		low: 17.214648
	},
	"2025-08-15": {
		high: 35.88636245,
		low: 17.34387923
	},
	"2025-08-18": {
		high: 35.45654587,
		low: 17.07604074
	},
	"2025-08-19": {
		high: 34.7144876,
		low: 16.9145782
	},
	"2025-08-20": {
		high: 25.6291493,
		low: 11.88226427
	},
	"2025-08-21": {
		high: 23.23157111,
		low: 10.76360315
	},
	"2025-08-22": {
		high: 24.02631528,
		low: 11.57691906
	},
	"2025-08-25": {
		high: 24.78988602,
		low: 12.00244192
	},
	"2025-08-26": {
		high: 23.99439092,
		low: 11.46982617
	},
	"2025-08-27": {
		high: 24.36651231,
		low: 11.65586859
	},
	"2025-08-28": {
		high: 24.58942529,
		low: 11.89625718
	},
	"2025-08-29": {
		high: 24.87428807,
		low: 12.07560559
	},
	"2025-09-01": {
		high: 24.36979194,
		low: 11.65186463
	},
	"2025-09-02": {
		high: 23.97684455,
		low: 11.59017729
	},
	"2025-09-03": {
		high: 23.65259273,
		low: 11.58102987
	},
	"2025-09-04": {
		high: 23.25854116,
		low: 11.37233805
	},
	"2025-09-05": {
		high: 23.81454853,
		low: 11.56091457
	},
	"2025-09-08": {
		high: 24.64133909,
		low: 11.99759059
	},
	"2025-09-09": {
		high: 24.01105772,
		low: 11.5832515
	},
	"2025-09-10": {
		high: 23.66400603,
		low: 11.46922343
	},
	"2025-09-11": {
		high: 23.84534477,
		low: 11.579578
	},
	"2025-09-12": {
		high: 24.61513919,
		low: 11.77589195
	},
	"2025-09-15": {
		high: 24.18958104,
		low: 11.70422606
	},
	"2025-09-16": {
		high: 24.19519758,
		low: 11.63930395
	},
	"2025-09-17": {
		high: 23.73251051,
		low: 11.49111784
	},
	"2025-09-18": {
		high: 23.24428314,
		low: 11.09345693
	},
	"2025-09-19": {
		high: 23.490331,
		low: 11.28094494
	},
	"2025-09-22": {
		high: 23.50736667,
		low: 11.39117995
	},
	"2025-09-23": {
		high: 23.59446032,
		low: 11.43751862
	},
	"2025-09-24": {
		high: 22.90181833,
		low: 10.96901189
	},
	"2025-09-25": {
		high: 21.88922015,
		low: 10.71180062
	},
	"2025-09-26": {
		high: 22.34019573,
		low: 10.90350957
	},
	"2025-09-29": {
		high: 22.64828294,
		low: 11.10684893
	},
	"2025-09-30": {
		high: 22.66515936,
		low: 11.02535309
	},
	"2025-10-01": {
		high: 23.17640836,
		low: 11.25657762
	},
	"2025-10-02": {
		high: 23.52041153,
		low: 11.55333082
	},
	"2025-10-03": {
		high: 23.95374013,
		low: 11.61715074
	},
	"2025-10-06": {
		high: 24.91695671,
		low: 11.99913651
	},
	"2025-10-07": {
		high: 24.19752762,
		low: 11.85813696
	},
	"2025-10-08": {
		high: 26.43224022,
		low: 12.77314632
	},
	"2025-10-09": {
		high: 26.50430269,
		low: 12.8625232
	},
	"2025-10-10": {
		high: 25.89676743,
		low: 12.64754851
	},
	"2025-10-13": {
		high: 25.77964744,
		low: 12.71144867
	},
	"2025-10-14": {
		high: 25.60278077,
		low: 12.5025347
	},
	"2025-10-15": {
		high: 26.92793438,
		low: 13.18995763
	},
	"2025-10-16": {
		high: 27.01490021,
		low: 13.12438007
	},
	"2025-10-17": {
		high: 26.22282256,
		low: 12.77896387
	},
	"2025-10-20": {
		high: 26.16255218,
		low: 12.82582393
	},
	"2025-10-21": {
		high: 25.92212982,
		low: 12.76248318
	},
	"2025-10-22": {
		high: 26.22163992,
		low: 12.8252943
	},
	"2025-10-23": {
		high: 26.18599532,
		low: 12.87547282
	},
	"2025-10-24": {
		high: 26.81533682,
		low: 13.15028406
	},
	"2025-10-27": {
		high: 27.37786169,
		low: 13.4316348
	},
	"2025-10-28": {
		high: 27.83387086,
		low: 13.41990422
	},
	"2025-10-29": {
		high: 27.01086349,
		low: 13.39009497
	},
	"2025-10-30": {
		high: 25.91840212,
		low: 12.86884775
	},
	"2025-10-31": {
		high: 25.68259888,
		low: 12.79647201
	},
	"2025-11-03": {
		high: 25.26687367,
		low: 12.58242275
	},
	"2025-11-04": {
		high: 24.52841208,
		low: 12.15059142
	},
	"2025-11-05": {
		high: 23.25475532,
		low: 11.40228204
	},
	"2025-11-06": {
		high: 20.81454998,
		low: 9.628789419
	},
	"2025-11-07": {
		high: 21.03090374,
		low: 10.22221097
	},
	"2025-11-10": {
		high: 21.0557959,
		low: 10.31871496
	},
	"2025-11-11": {
		high: 20.7259701,
		low: 10.26536894
	},
	"2025-11-12": {
		high: 20.58292798,
		low: 10.20180559
	},
	"2025-11-13": {
		high: 20.62267476,
		low: 10.05997838
	},
	"2025-11-14": {
		high: 20.22758319,
		low: 9.986686449
	},
	"2025-11-17": {
		high: 20.34848996,
		low: 9.945042613
	},
	"2025-11-18": {
		high: 21.89533129,
		low: 10.55062135
	},
	"2025-11-19": {
		high: 21.52961293,
		low: 10.67198181
	},
	"2025-11-20": {
		high: 22.06859262,
		low: 10.85471986
	},
	"2025-11-21": {
		high: 21.73960747,
		low: 10.74910624
	},
	"2025-11-24": {
		high: 22.74716113,
		low: 10.89475
	},
	"2025-11-25": {
		high: 22.62159593,
		low: 11.02620396
	},
	"2025-11-26": {
		high: 23.88398092,
		low: 11.58926203
	},
	"2025-11-27": {
		high: 23.69911608,
		low: 11.76022766
	},
	"2025-11-28": {
		high: 24.00911341,
		low: 11.84756978
	},
	"2025-12-01": {
		high: 23.77519917,
		low: 11.78557842
	},
	"2025-12-02": {
		high: 23.6231323,
		low: 11.70352704
	},
	"2025-12-03": {
		high: 23.67290367,
		low: 11.59447659
	},
	"2025-12-04": {
		high: 24.17304985,
		low: 11.77270084
	},
	"2025-12-05": {
		high: 23.89725891,
		low: 11.67161718
	},
	"2025-12-08": {
		high: 23.83121871,
		low: 11.67165142
	},
	"2025-12-09": {
		high: 23.25865526,
		low: 11.37438903
	},
	"2025-12-10": {
		high: 23.09386219,
		low: 11.25357963
	},
	"2025-12-11": {
		high: 24.4988508,
		low: 11.78517971
	},
	"2025-12-12": {
		high: 24.37820543,
		low: 11.96251099
	},
	"2025-12-15": {
		high: 24.70086719,
		low: 12.13512649
	},
	"2025-12-16": {
		high: 24.42087118,
		low: 11.88461776
	},
	"2025-12-17": {
		high: 24.20297223,
		low: 11.87813364
	},
	"2025-12-18": {
		high: 24.03760338,
		low: 11.77711668
	},
	"2025-12-19": {
		high: 24.50193673,
		low: 11.90831628
	},
	"2025-12-22": {
		high: 24.74860744,
		low: 12.06221891
	},
	"2025-12-23": {
		high: 25.18927466,
		low: 12.2062475
	},
	"2025-12-24": {
		high: 24.87446787,
		low: 12.13488231
	},
	"2025-12-29": {
		high: 25.11478482,
		low: 12.26814002
	},
	"2025-12-30": {
		high: 25.50405655,
		low: 12.34402463
	},
	"2025-12-31": {
		high: 24.89191353,
		low: 12.18627958
	},
	"2026-01-02": {
		high: 25.25935346,
		low: 12.22401456
	},
	"2026-01-05": {
		high: 25.11730944,
		low: 12.14084678
	},
	"2026-01-06": {
		high: 25.67629466,
		low: 12.38225726
	},
	"2026-01-07": {
		high: 25.77246153,
		low: 12.58008677
	},
	"2026-01-08": {
		high: 24.90473544,
		low: 12.02626996
	},
	"2026-01-09": {
		high: 26.01145638,
		low: 12.69448861
	},
	"2026-01-12": {
		high: 28.141796,
		low: 13.55269172
	},
	"2026-01-13": {
		high: 27.92766915,
		low: 13.70052999
	},
	"2026-01-14": {
		high: 27.84750937,
		low: 13.70000842
	},
	"2026-01-15": {
		high: 28.13969377,
		low: 13.89477421
	},
	"2026-01-16": {
		high: 28.83347473,
		low: 14.18569634
	},
	"2026-01-19": {
		high: 28.74232202,
		low: 13.62192005
	},
	"2026-01-20": {
		high: 28.31934697,
		low: 13.45488813
	},
	"2026-01-21": {
		high: 28.32710287,
		low: 13.8493328
	},
	"2026-01-22": {
		high: 29.2204461,
		low: 14.21421739
	},
	"2026-01-23": {
		high: 30.00930553,
		low: 14.39934357
	},
	"2026-01-27": {
		high: 29.7238367,
		low: 13.89439414
	},
	"2026-01-28": {
		high: 29.23017354,
		low: 13.77313882
	},
	"2026-01-29": {
		high: 28.70550435,
		low: 13.61118255
	},
	"2026-01-30": {
		high: 28.39268193,
		low: 13.44624205
	},
	"2026-02-02": {
		high: 27.49345245,
		low: 13.19233485
	},
	"2026-02-03": {
		high: 28.05982726,
		low: 13.46470315
	},
	"2026-02-04": {
		high: 28.42189227,
		low: 13.5408847
	},
	"2026-02-05": {
		high: 28.2333391,
		low: 13.69747877
	},
	"2026-02-06": {
		high: 28.01504013,
		low: 13.2784567
	},
	"2026-02-09": {
		high: 28.72702519,
		low: 13.79039528
	},
	"2026-02-10": {
		high: 28.21671866,
		low: 13.63769122
	},
	"2026-02-11": {
		high: 32.40053873,
		low: 14.53957572
	},
	"2026-02-12": {
		high: 32.01496981,
		low: 15.28329171
	},
	"2026-02-13": {
		high: 31.48893431,
		low: 15.10787147
	},
	"2026-02-16": {
		high: 31.28450549,
		low: 15.01676011
	},
	"2026-02-17": {
		high: 30.95145328,
		low: 15.00862657
	},
	"2026-02-18": {
		high: 30.45942616,
		low: 14.78441362
	},
	"2026-02-19": {
		high: 30.45672381,
		low: 14.79337061
	},
	"2026-02-20": {
		high: 30.08010879,
		low: 14.56739794
	},
	"2026-02-23": {
		high: 29.91874965,
		low: 14.47292445
	},
	"2026-02-24": {
		high: 29.62262687,
		low: 14.35790099
	},
	"2026-02-25": {
		high: 30.77997008,
		low: 14.86814822
	},
	"2026-02-26": {
		high: 29.930523,
		low: 14.50192916
	},
	"2026-02-27": {
		high: 29.85745583,
		low: 14.44119635
	},
	"2026-03-02": {
		high: 28.95677332,
		low: 14.1893832
	},
	"2026-03-03": {
		high: 28.36546238,
		low: 13.71418878
	},
	"2026-03-04": {
		high: 27.58464596,
		low: 13.1346163
	},
	"2026-03-05": {
		high: 26.54990016,
		low: 13.11905996
	},
	"2026-03-06": {
		high: 26.68297621,
		low: 13.01267072
	},
	"2026-03-09": {
		high: 25.41182462,
		low: 12.12534622
	},
	"2026-03-10": {
		high: 25.88471478,
		low: 12.61641706
	},
	"2026-03-11": {
		high: 25.34020781,
		low: 12.46454771
	},
	"2026-03-12": {
		high: 24.60898538,
		low: 12.06837235
	},
	"2026-03-13": {
		high: 23.73766281,
		low: 11.76190415
	},
	"2026-03-16": {
		high: 24.08262231,
		low: 11.81072297
	},
	"2026-03-17": {
		high: 24.22925322,
		low: 11.80657505
	},
	"2026-03-18": {
		high: 24.52074995,
		low: 12.0201314
	},
	"2026-03-19": {
		high: 24.24268192,
		low: 11.89899534
	},
	"2026-03-20": {
		high: 23.38663801,
		low: 11.5493335
	},
	"2026-03-23": {
		high: 22.9918567,
		low: 11.07248193
	},
	"2026-03-24": {
		high: 23.79020979,
		low: 11.51510601
	},
	"2026-03-25": {
		high: 23.89212696,
		low: 11.68240516
	},
	"2026-03-26": {
		high: 23.51855931,
		low: 11.47795308
	},
	"2026-03-27": {
		high: 22.54740313,
		low: 11.14467403
	},
	"2026-03-30": {
		high: 21.66287578,
		low: 10.76211208
	},
	"2026-03-31": {
		high: 21.71009053,
		low: 10.5916529
	},
	"2026-04-01": {
		high: 23.38779496,
		low: 11.42809112
	},
	"2026-04-02": {
		high: 23.31521401,
		low: 11.37046137
	},
	"2026-04-07": {
		high: 23.40254867,
		low: 11.42879646
	},
	"2026-04-08": {
		high: 24.99982393,
		low: 11.95282944
	},
	"2026-04-09": {
		high: 24.68586962,
		low: 12.07436433
	},
	"2026-04-10": {
		high: 24.91616246,
		low: 12.10761845
	},
	"2026-04-13": {
		high: 24.9255129,
		low: 12.0446657
	},
	"2026-04-14": {
		high: 25.50609018,
		low: 12.30517986
	},
	"2026-04-15": {
		high: 25.52953573,
		low: 12.37134378
	},
	"2026-04-16": {
		high: 24.22940608,
		low: 11.73642948
	},
	"2026-04-17": {
		high: 24.34431163,
		low: 11.84817388
	},
	"2026-04-20": {
		high: 25.85442175,
		low: 12.37254275
	},
	"2026-04-21": {
		high: 26.30988051,
		low: 12.84271777
	},
	"2026-04-22": {
		high: 26.63631678,
		low: 13.02134971
	},
	"2026-04-23": {
		high: 26.40492687,
		low: 12.80684698
	},
	"2026-04-24": {
		high: 26.83936268,
		low: 13.02072061
	},
	"2026-04-27": {
		high: 26.56934726,
		low: 12.92169255
	},
	"2026-04-28": {
		high: 26.7267871,
		low: 12.99998127
	},
	"2026-04-29": {
		high: 26.1641808,
		low: 12.7775448
	},
	"2026-04-30": {
		high: 25.34627235,
		low: 12.08579872
	},
	"2026-05-01": {
		high: 25.44676621,
		low: 12.30431463
	},
	"2026-05-04": {
		high: 25.13043977,
		low: 12.14430732
	},
	"2026-05-05": {
		high: 24.13151677,
		low: 11.64062558
	},
	"2026-05-06": {
		high: 24.49528937,
		low: 11.90042878
	},
	"2026-05-07": {
		high: 25.62376095,
		low: 12.35919288
	},
	"2026-05-08": {
		high: 24.96577203,
		low: 11.95860718
	},
	"2026-05-11": {
		high: 25.21958431,
		low: 12.19008099
	},
	"2026-05-12": {
		high: 24.52277021,
		low: 11.95371906
	},
	"2026-05-13": {
		high: 24.48268604,
		low: 11.89456042
	},
	"2026-05-14": {
		high: 23.93865881,
		low: 11.65195495
	},
	"2026-05-15": {
		high: 23.63133403,
		low: 11.55180117
	},
	"2026-05-18": {
		high: 23.27801187,
		low: 11.01072147
	},
	"2026-05-19": {
		high: 23.50159085,
		low: 11.41615501
	}
};
